import React, {useState} from 'react';
// import Tooltip from "@material-ui/core/Tooltip";
import {BRCustomizedTooltip as Tooltip} from "../../../../../components/customBreachBits/accents/BRCustomizedTooltip";
import Banner from "../../../../../assets/images/BreachRisk_Portfolio_Banner.svg";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {useDispatch, useSelector} from "react-redux";
import TileBreachRiskScoreWithBasicDial
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskScoreWithBasicDial";
import BRPPortfolioEntitiesTable
    from "../../../../../components/customBreachBits/BRPortfolio/BRPPortfolioEntitiesTable";
import TileBreachRiskPortfolioInsightsRiskCategories
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskPortfolioInsightsRiskCategories";
import {
    bbFindSubportfolioWithinPortfolio,
    bbGetSortedArrayOfSubportfoliosFromPortfolioObject,
    filterObject
} from "../../../../../util/bbHelpers";
import PortfolioEntityRisk2DScatterPlot
    from "../../../../../components/customBreachBits/charts/PortfolioEntityRisk2DScatterPlot";
import TileBreachRiskPortfolioInsightLargestOrganization
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskPortfolioInsightLargestOrganization";
import TileBreachRiskPortfolioInsightMostHumans
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskPortfolioInsightMostHumans";
import TileBreachRiskPortfolioInsightMostVectors
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskPortfolioInsightMostVectors";
import TileBreachRiskPortfolioInsightMostServices
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskPortfolioInsightMostServices";
import TilePortfolioFidelity from "../../../../../components/customBreachBits/metrics/TilePortfolioFidelity";
import TileBreachRiskPortfolioScoreSimple
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskPortfolioScoreSimple";
import TileBreachRiskPortfolioNumEntitiesSimple
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskPortfolioNumEntitiesSimple";
import BreachRiskScoreCyclePendingModal
    from "../../../../../components/customBreachBits/modals/BreachRiskScoreCyclePendingModal";
import {HashLink as Link} from "react-router-hash-link";
import BBIconIsGroupCollection from "../../../../../assets/bbCustomIcons/BBIconIsGroupCollection";
import Widget from "../../../../../components/prefabricated/Widget";
import {Paper} from "@mui/material";
import EarlyAccessWrapper from "../../../../../components/customBreachBits/settings/EarlyAccessWrapper";
import Skeleton from "react-loading-skeleton";
import {Col, Row} from "reactstrap";
import SubportfolioInViewSelect from "../../../../../components/customBreachBits/settings/SubportfolioInViewSelect";
import {setSubportfolioInView} from "../../../../../actions";

const Dashboard= (props) => {

    const {customerInView, customers} = useSelector(({customer}) => customer);
    const {portfolios, selfEntityId, loadingPortfolios, subportfolioInView} = useSelector(({breachrisk})=> breachrisk);
    const customerIdToUse = customers ? customerInView ? customerInView : null : null;

    const dispatch = useDispatch();

    const subportfolioInViewObject = portfolios && customerInView && subportfolioInView ? bbFindSubportfolioWithinPortfolio(subportfolioInView, portfolios[customerInView]) : null;

    const entities = portfolios
    && customerInView
    && portfolios[customerInView]
        ? filterObject(portfolios[customerInView].entities, (_, entity) => entity.id !== selfEntityId)
        : null;

    const arrayOfEntitiesSortedByScore =  entities ? Object.keys(entities).map((k) => entities[k]).filter(entity => !!entity.last_cycle) : [];
    arrayOfEntitiesSortedByScore.sort(function(a, b) {
        const textA = a.last_cycle ? parseFloat(a.last_cycle.score).toFixed(1) : null;
        const textB = b.last_cycle ? parseFloat(b.last_cycle.score).toFixed(1) : null;
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });

    // console.log("arrayOfEntitiesSortedByScore", arrayOfEntitiesSortedByScore);
    const [showMicroWidgets, setShowMicroWidgets] = useState(true);


    const entityWithBestScore = arrayOfEntitiesSortedByScore.shift();
    // const entityWithSecondBestScore = arrayOfEntitiesSortedByScore.shift();
    const entityWithWorstScore = arrayOfEntitiesSortedByScore.pop();
    // const entityWithSecondWorstScore = arrayOfEntitiesSortedByScore.pop();


    const arrayOfEntitiesSortedByFidelityRange =  entities ? Object.keys(entities).map((k) => entities[k]).filter(entity => !!entity.last_cycle) : [];
    arrayOfEntitiesSortedByFidelityRange.sort(function(a, b) {
        const textA = a.last_cycle ? parseFloat(a.last_cycle.confidence_high).toFixed(1) - parseFloat(a.last_cycle.confidence_low).toFixed(1) : null;
        const textB = b.last_cycle ? parseFloat(b.last_cycle.confidence_high).toFixed(1) - parseFloat(b.last_cycle.confidence_low).toFixed(1) : null;
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });

    // console.log("arrayOfEntitiesSortedByFidelityRange", arrayOfEntitiesSortedByFidelityRange);

    const entityWithBestFidelity = arrayOfEntitiesSortedByFidelityRange.shift();
    const entityWithWorstFidelity = arrayOfEntitiesSortedByFidelityRange.pop();

    /*  jfd**********22.Dec.01.00:07*****
     *   Portfolio Groups prep
         ********************** `--===<>==<>==C>-< */
    const subportfolios = portfolios && portfolios[customerIdToUse] && portfolios[customerIdToUse].portfolios ? portfolios[customerIdToUse].portfolios : null;

    const arrayOfSubportfolios = subportfolios ? bbGetSortedArrayOfSubportfoliosFromPortfolioObject(portfolios[customerIdToUse]) : null;
    const numSubportfolios = arrayOfSubportfolios && Array.isArray(arrayOfSubportfolios) && arrayOfSubportfolios.length;

    const portfolioGroupsSection = <>
        {arrayOfSubportfolios && arrayOfSubportfolios.map((subportfolio, key) => {

            if(subportfolio.entities && Array.isArray(subportfolio.entities) && subportfolio.entities.length > 0) {

                const widget = <div className={showMicroWidgets ? "col-4" : "col-12"} key={`${key}_portfolioGroupsSection`} onClick={()=>dispatch(setSubportfolioInView(subportfolio.id))} style={{cursor: "pointer"}}>
                                    <BRPPortfolioEntitiesTable
                                        showManagementOptions={!showMicroWidgets}
                                        showAnalyticsView={!showMicroWidgets}
                                        showInsightsDetails={!showMicroWidgets}
                                        showSlimView
                                        hideTitleHeader
                                        // showCustomerProcessSteps
                                        showAnalyticsWidget
                                        tableTitleText={`${subportfolio.name}`}
                                        tableDescription={subportfolio.description && `Group description: ${subportfolio.description}`}
                                        tableTitleIcon={<Tooltip
                                            title={"This is a portfolio group"}><span><BBIconIsGroupCollection/></span></Tooltip>}
                                        // tableTipText={"Manage the companies in your portfolio by adding or deleting. Ask for access to reports from companies currently in you portfolio."}
                                        showOnlyEntitiesFromTheseSubportfolios={[subportfolio]}
                                        primarySubportfolioInView={subportfolio}
                                        showMicroAnalyticsWidget={showMicroWidgets}
                                    />
                                </div>

                return widget;

            } else {
                //don't include subportfolios with no entities
                return <div className={showMicroWidgets ? "col-4" : "col-12"} key={`${key}_portfolioGroupsSection`}>
                    <Link to={{pathname: "/board/BreachRisk/Portfolio/Manage", hash:"BRPSubportfoliosManagementTableSection"}}>
                        <Paper className={"p-1 mx-0 my-2"}>
                            <Row>
                                <Col>
                                    <h1 className={"p-1 m-1 text-left"}><Tooltip
                                        title={"This is a portfolio group"}><span><BBIconIsGroupCollection/></span></Tooltip> {subportfolio && subportfolio.name}</h1>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className={"px-1"}>
                                        <em>This portfolio group doesn't have any companies yet. <Link to={{pathname: "/board/BreachRisk/Portfolio/Manage", hash:"BRPSubportfoliosManagementTableSection"}}>Go to the Manage Portfolio page</Link> to add companies to this group</em>
                                    </div>
                                </Col>
                            </Row>
                        </Paper>
                    </Link>

                </div>;
            }
            })
        }


    </>
console.log("Looking for subportfolioinview value", subportfolioInView, "looking at all subportfolios", subportfolios);
    return (
        // <MultiBoardWrapper customer={customer}>
        <div className="app-wrapper">
      <div className="animated fadeIn animation-duration-7">
          <div className="row">
              <div className={"col-8 align-self-center"}>
                  <div className={"mx-0 px-0"}>
                      <div style={{backgroundImage: `url(${Banner})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>

                  </div>
              </div>
              <div className={"col-4 align-self-center"}>
                  <h3>Predict threats and protect your portfolio.</h3>
                  <p>Discover and predict threats to your portfolio before a breach. These insights and comparison tools allow you to monitor risk from a distance or continue a productive security discussion.</p>
                  <p>Learn More About Using Subportfolios &nbsp; <Tooltip title={" "} heading={"Subportfolios"} link={"https://support.breachbits.com/knowledge/make-subportfolio-group"}>
                      <InfoSharpIcon className={"d-inline "} style={{fontSize:".75rem"}}/>
                  </Tooltip></p>

              </div>
          </div>
          {/*<EarlyAccessWrapper hideVisibleWrapper>*/}
              <Row >
                  <Col sm={5} className={"tourSelectPortfolioElement"}  id={"tourSelectPortfolioGroup"}>
                      {/*<EarlyAccessWrapper>*/}
                      {/*<Tooltip title={" "} heading={"Subportfolios"} link={"https://support.breachbits.com/knowledge/make-subportfolio-group"}>*/}
                          <SubportfolioInViewSelect/>
                      {/*</Tooltip>*/}
                      {/*</EarlyAccessWrapper>*/}
                  </Col>
              </Row>
          {/*</EarlyAccessWrapper>*/}
          <br/>
          <hr/>
          <br/>
          <BreachRiskScoreCyclePendingModal isBRPView disableForSingleEntityViewCases>
            {/*<h1>Portfolio Score</h1>*/}
          {/*<div className={"row align-self-center"}>*/}
          {/*    <div className="col-sm-6 col-12 align-self-center">*/}
          {/*        <TileBreachRiskPortfolioScoreSimple/>*/}
          {/*    </div>*/}
          {/*    /!*<div className="col-1" />*!/*/}
          {/*    <div className="col-sm-6 col-12 align-self-center">*/}
          {/*        <TileBreachRiskPortfolioNumEntitiesSimple/>*/}
          {/*    </div>*/}

          {/*</div>*/}

              {/*<EarlyAccessWrapper hideVisibleWrapper>*/}
                  <Row >
                      <Col id={"tourSelectedFocus"}>
                          {subportfolioInView && subportfolioInViewObject
                              ? <h1>Group Focus</h1>
                              : <h1>Portfolio Groups</h1>
                          }
                      </Col>
                  </Row>
              {/*</EarlyAccessWrapper>*/}

              {subportfolioInView && subportfolioInViewObject
                  ? <section className={"m-0 p-0 tourSelectedFocusElement"} >
                      {/*<EarlyAccessWrapper>*/}
                      <Row>
                          <Col>
                              <BRPPortfolioEntitiesTable
                                  showManagementOptions
                                  showAnalyticsView
                                  showInsightsDetails
                                  showSlimView
                                  hideTitleHeader
                                  // showCustomerProcessSteps
                                  showAnalyticsWidget
                                  tableTitleText={`${subportfolioInViewObject.name}`}
                                  tableDescription={subportfolioInViewObject.description && `Group description: ${subportfolioInViewObject.description}`}
                                  tableTitleIcon={<Tooltip
                                      title={"This is a portfolio group"}><span><BBIconIsGroupCollection/></span></Tooltip>}
                                  // tableTipText={"Manage the companies in your portfolio by adding or deleting. Ask for access to reports from companies currently in you portfolio."}
                                  showOnlyEntitiesFromTheseSubportfolios={[subportfolioInViewObject]}
                                  primarySubportfolioInView={subportfolioInViewObject}
                                  showRiskCategoriesPieInsteadOfTable={subportfolioInViewObject}
                              />
                          </Col>
                      </Row>

                      <br/>

                          <Row>
                              <Col>
                                  <BRPPortfolioEntitiesTable
                                      showManagementOptions
                                      // showAnalyticsView
                                      // showInsightsDetails
                                      // showSlimView
                                      showCustomerProcessSteps
                                      // showAnalyticsWidget
                                      tableTitleText={`${subportfolioInViewObject.name}`}
                                      tableDescription={subportfolioInViewObject.description && `Group description: ${subportfolioInViewObject.description}`}
                                      tableTitleIcon={<Tooltip
                                          title={"This is a portfolio group"}><span><BBIconIsGroupCollection/></span></Tooltip>}
                                      // tableTipText={"Manage the companies in your portfolio by adding or deleting. Ask for access to reports from companies currently in you portfolio."}
                                      showOnlyEntitiesFromTheseSubportfolios={[subportfolioInViewObject]}
                                      primarySubportfolioInView={subportfolioInViewObject}
                                  />
                              </Col>


                          </Row>
                      {/*</EarlyAccessWrapper>*/}
                  </section>
                  : <section className={"m-0 p-0 tourSelectedFocusElement"} >
                      {/*<EarlyAccessWrapper>*/}
                      {/*    <h1>Portfolio Groups</h1>*/}
                          {numSubportfolios
                              ? <Row>
                                  {portfolioGroupsSection}
                              </Row>
                              : !portfolios || loadingPortfolios[customerInView] ? <Skeleton /> : <p><em>You don't have any portfolio groups yet. <Link to={{pathname: "/board/BreachRisk/Portfolio/Manage", hash:"BRPSubportfoliosManagementTableSection"}}>Go to the Manage Portfolio page</Link> to add groups.</em></p>
                          }

                      {/*</EarlyAccessWrapper>*/}
                      {/*<EarlyAccessWrapper hideVisibleWrapper>*/}
                      <br/>
                          <hr/>
                      {/*</EarlyAccessWrapper>*/}
                        <br/>
                      <Row id={"tourIdAllCompanies"}>
                          <Col>
                              <h1 >All Companies</h1>
                          </Col>
                      </Row>

                      <div className="row" >
                          <div className="col-6 " >
                              <PortfolioEntityRisk2DScatterPlot/>
                          </div>
                          {/*{entityWithBestScore && entityWithWorstFidelity*/}
                          {/*    ? null*/}
                          {/*    : <div className={"col-2"}/> }*/}

                          { entityWithBestScore ?
                              <div className="col-3">
                                  {/*Best Score*/}
                                  <Link smooth to={`Details/Scores?entityID=${entityWithBestScore.id}`}>
                                      <TileBreachRiskScoreWithBasicDial
                                          entityId={entityWithBestScore.id}
                                          displaySmall
                                          overrideRibbonText={"Best Score"}
                                          tipTextOverride={"This company was found to have the best score in your portfolio."}
                                      />
                                  </Link>
                              </div>
                              : <div className={"col-3"}/>
                          }

                          { entityWithWorstScore &&
                              <div className="col-3">
                                  <Link smooth to={`Details/Scores?entityID=${entityWithWorstScore.id}`}>
                                      <TileBreachRiskScoreWithBasicDial
                                          entityId={entityWithWorstScore.id}
                                          displaySmall
                                          overrideRibbonText={"Worst Score"}
                                          tipTextOverride={"This company was found to have the worst score in your portfolio."}

                                      />
                                  </Link>
                              </div>
                          }

                      </div>
                      <br />
                      <Row className="row" >

                          <Col className="col-sm-9 col-12" id={"tourCompaniesRanked"}>
                              <BRPPortfolioEntitiesTable
                                  showInsightsDetails
                                  tableTitleText={"All Companies Ranked"}
                                  tableTipText={"Insights across entire portfolio. By default companies are ordered from best to worse score."}

                              />
                          </Col>
                          <div className="col-sm-3 col-12">
                              <TileBreachRiskPortfolioInsightsRiskCategories />
                          </div>


                      </Row>
                  </section>
                  }

              {!subportfolioInView && !subportfolioInViewObject &&
                <>
                    <hr/>

                    <Row >
                        <Col>
                            <Tooltip title={"Collateral Risks don't directly influence Risk Scores, but can be an indication of other aspects of risk and security."}>
                                <span id={"tourCollateralRisk"}>
                                    <h1>Collateral Risk Indicators      <InfoSharpIcon/></h1>
                                </span>
                            </Tooltip>
                        </Col>
                    </Row>


                    <div className="row">

                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">

                        </div>

                        { entityWithBestFidelity &&
                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                                <Link smooth to={`Details/Scores?entityID=${entityWithBestFidelity.id}`} style={{ textDecoration: "none", color: "black" }}>
                                    <TilePortfolioFidelity entityId={entityWithBestFidelity.id}
                                                           title={"Best Fidelity"}/>
                                </Link>
                            </div>
                        }

                        { entityWithWorstFidelity &&
                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                                <Link smooth to={`Details/Scores?entityID=${entityWithWorstFidelity.id}`} style={{ textDecoration: "none", color: "black" }}>
                                    <TilePortfolioFidelity entityId={entityWithWorstFidelity.id}
                                                           title={"Worst Fidelity"}/>
                                </Link>
                            </div>
                        }

                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">

                        </div>

                    </div>

                    <div className="row">

                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">

                            <TileBreachRiskPortfolioInsightMostVectors/>

                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">

                            <TileBreachRiskPortfolioInsightMostServices/>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">

                            <TileBreachRiskPortfolioInsightLargestOrganization/>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">

                            <TileBreachRiskPortfolioInsightMostHumans/>
                        </div>

                    </div>
                </>
              }



          {/*<div className="row">*/}
          {/*    <div className="col-12">*/}
          {/*        <PortfolioInsightsMultiEntityRiskScoreLineChart/>*/}
          {/*    </div>*/}
          {/*</div>*/}

          </BreachRiskScoreCyclePendingModal>
      </div>
        </div>
        // {/*</MultiBoardWrapper>*/}
    )
}
export default Dashboard;